import { scrollToComponentModule } from '../../scroll-to/scroll-to';
import { appAlertComponentModule } from '../../app-alert/app-alert';

const APP_ALERT_OFFSET_HEIGHT = 85;

export const scrollToErrorComponentModule = angular
  .module('Q.components.forms.scroll-to-error', [
    scrollToComponentModule,
    appAlertComponentModule,
  ])

  /**
   * @docType shared
   * @category directive
   *
   * @ngdoc directive
   * @name scrollToError
   * @restrict A
   * @description
   * Scrolls to the first form group or element marked with an error whenever a form is submitted.
   *
   * @param {string} scrollTarget Optional selector to pick the scrolling target, defaults the nearest scrollable element.
   * @param {string} relativeParent Optional selector to pick a parent to calculate relative offsets (for example, if there's a fixed header), defaults to the scroll target.
   * @param {expression} scrollToErrorOffset If provided, the scroll-to position is offset by the given amount.  If not provided and showMessage is enabled, the offset amount will be determined by the alert.
   * @param {string} showMessage If `true`, shows an app-alert message on error.  If any other string, shows that message.  If not provided, no message shown.
   * @param {expression} scrollToError Can be used to change the document before showing the error
   *
   * @example
   *   <form ng-submit="myControl.save()" scroll-to-error>...</form>
   */
  .directive('scrollToError', function (scrollToElement, $timeout, appAlert) {
    return {
      restrict: 'A',
      require: 'form',
      priority: -1,
      link(scope, elem, attrs, ngFormCtrl) {
        let errorAlert = { close: angular.noop };
        scope.$watch(
          () => ngFormCtrl.$valid,
          (valid) => {
            if (valid) {
              errorAlert.close();
            }
          },
        );
        scope.$on('$destroy', () => {
          errorAlert.close();
        });

        ngFormCtrl.scrollToError = () => {
          if (ngFormCtrl.$invalid) {
            if (attrs.showMessage) {
              let msg = 'Please fix the marked errors';
              if (
                attrs.showMessage !== 'true' &&
                attrs.showMessage !== 'show-message'
              ) {
                msg = attrs.showMessage;
              }
              errorAlert = appAlert.error(msg);
            }
            if (attrs.scrollToError) {
              scope.$eval(attrs.scrollToError);
            }

            $timeout(() => {
              let firstErrorElem =
                elem[0].querySelector('.form-group.has-error') ||
                elem[0].querySelector('.ng-invalid');
              if (firstErrorElem) {
                let offset = 0;
                if (attrs.scrollToErrorOffset) {
                  offset = scope.$eval(attrs.scrollToErrorOffset);
                } else if (attrs.showMessage) {
                  offset = APP_ALERT_OFFSET_HEIGHT;
                }

                scrollToElement({
                  target: firstErrorElem,
                  scrollTarget: attrs.scrollTarget,
                  relativeParent: attrs.relativeParent,
                  ignoreIfVisible: true,
                  offset,
                }).then(() => {
                  let errorInputElement = firstErrorElem;
                  if (
                    ['INPUT', 'SELECT', 'TEXTAREA'].indexOf(
                      errorInputElement.nodeName,
                    ) === -1
                  ) {
                    // the element isn't necessarily focusable, so look for an invalid child input element
                    errorInputElement = firstErrorElem.querySelector(
                      'input.ng-invalid, select.ng-invalid, textarea.ng-invalid',
                    );
                  }
                  if (!errorInputElement) {
                    // OK, that didn't work, now look for any child input element
                    errorInputElement = firstErrorElem.querySelector(
                      'input, select, textarea',
                    );
                  }
                  if (errorInputElement && errorInputElement.focus) {
                    // set the focus out-of-$digest, since this is a DOM command
                    $timeout(() => errorInputElement.focus(), 1, false);
                  }
                });
              }
            });
          }
        };
        elem.on('submit', ngFormCtrl.scrollToError);
      },
    };
  });
